import React from "react";
import { Textarea } from "../../../sudokit/components/Textarea";
import { WordCountHint } from "./WordCountHint";

export const ContextInputsSection = ({
  userInputText,
  userTextInputValue,
  onUserTextInputChange,
  userTextInputLimits,
  shouldShowPrecedingText,
  precedingTextValue,
  onPrecedingTextChange,
  precedingTextLimits,
  shouldShowFollowingText,
  followingTextValue,
  onFollowingTextChange,
  followingTextLimits,
  shouldShowPreviousDocumentText,
  previousDocumentTextValue,
  onPreviousDocumentTextChange,
  previousDocTextLimits,
}) => {
  return (
    <>
      {userInputText && (
        <label htmlFor="plugin-tester-user-text-input" className="testerFieldLabel">
          <h3 id="plugin-tester-user-text-input-label" className="testerFieldHeading">User Text Input: the answer to the prompt "{userInputText.instructionsText}"</h3>
          <Textarea
            id="plugin-tester-user-text-input"
            placeholder="Answer the question as if you invoked the plugin from the editor's plugin menu"
            value={userTextInputValue}
            aria-labelledby="plugin-tester-user-text-input-label"
            onChange={(e) => onUserTextInputChange(e.target.value)}
            lineHeight={1.5}
            minRows={5}
            className="test-message"
          />
          <WordCountHint text={userTextInputValue} limits={userTextInputLimits} />
        </label>
      )}

      {(shouldShowPrecedingText || shouldShowFollowingText || shouldShowPreviousDocumentText) && (
        <div className="mb-4 mt-2">
          {shouldShowPrecedingText && (
            <label htmlFor="plugin-tester-preceding-text" className="testerFieldLabel">
              <h3 id="plugin-tester-preceding-text-label" className="testerFieldHeading testerFieldHeading--stacked">Preceding Text</h3>
              <Textarea
                id="plugin-tester-preceding-text"
                value={precedingTextValue}
                placeholder={"Paste or type an example input for the preceding text."}
                aria-labelledby="plugin-tester-preceding-text-label"
                onChange={(e) => onPrecedingTextChange(e.target.value)}
                lineHeight={1.5}
                minRows={10}
                className="test-message"
              />
              <WordCountHint text={precedingTextValue} limits={precedingTextLimits} />
            </label>
          )}
          {shouldShowFollowingText && (
            <label htmlFor="plugin-tester-following-text" className="testerFieldLabel">
              <h3 id="plugin-tester-following-text-label" className="testerFieldHeading testerFieldHeading--stacked">Following Text</h3>
              <Textarea
                id="plugin-tester-following-text"
                value={followingTextValue}
                placeholder={"Paste or type an example input for the following text."}
                aria-labelledby="plugin-tester-following-text-label"
                onChange={(e) => onFollowingTextChange(e.target.value)}
                lineHeight={1.5}
                minRows={10}
                className="test-message"
              />
              <WordCountHint text={followingTextValue} limits={followingTextLimits} />
            </label>
          )}
          {shouldShowPreviousDocumentText && (
            <label htmlFor="plugin-tester-previous-document-text" className="testerFieldLabel">
              <h3 id="plugin-tester-previous-document-text-label" className="testerFieldHeading testerFieldHeading--compact">Previous Document Text</h3>
              <Textarea
                id="plugin-tester-previous-document-text"
                value={previousDocumentTextValue}
                placeholder={"Paste or type an example input for the previous document text."}
                aria-labelledby="plugin-tester-previous-document-text-label"
                onChange={(e) => onPreviousDocumentTextChange(e.target.value)}
                lineHeight={1.5}
                minRows={10}
                className="test-message"
              />
              <WordCountHint text={previousDocumentTextValue} limits={previousDocTextLimits} />
            </label>
          )}
        </div>
      )}
    </>
  );
};
